import { HYDRATE } from 'next-redux-wrapper';
import { combineReducers } from 'redux';

import { categories } from './common/categories/reducer';
import { provinces } from './common/provinces/reducer';
import { home } from './home/reducer';
import { landing } from './landing/reducer';
import { filters } from './search/reducer';
import { setting } from './settings/reducer';
import { stores } from './stores/reducer';

const appReducer = combineReducers({
	setting,
	filters,
	stores,
	home,
	provinces,
	categories,
	landing,
});

const rootReducer = (state, action) => {
	if (action.type === HYDRATE) {
		const nextState = {
			...state,
			...action.payload,
		};
		return nextState;
	}
	return appReducer(state, action);
};

export default rootReducer;
